<template>
  <div style="margin: 20px">
    <!-- Пользователи -->
    <div style="display: flex; gap: 10px; flex-wrap: wrap">
      <button @click="addUserShow()" class="btn btn-primary">
        Добавить пользователя
      </button>
      <button @click="qr = true" class="btn btn-primary">Пропуски</button>
      <button @click="showImportModal = true" class="btn btn-primary">
        Импорт пользователей из Excel
      </button>
      <button @click="exportToExcel()" class="btn btn-success">
        📥 Экспорт в Excel
      </button>
    </div>

    <!-- Фильтры и поиск -->
    <div class="filters-row">
      <input
        v-model="search"
        type="text"
        placeholder="Поиск по логину..."
        class="filter-input"
      />

      <select v-model="roleFilter" class="filter-select">
        <option :value="null">Все роли</option>
        <option v-for="r in roleOptions" :key="r.value" :value="r.value">
          {{ r.text }}
        </option>
      </select>

      <select v-model="passFilter" class="filter-select">
        <option :value="null">Все пропуска</option>
        <option v-for="p in passFilterOptions" :key="p.value" :value="p.value">
          {{ p.text }}
        </option>
      </select>

      <select v-model="maxIdFilter" class="filter-select">
        <option :value="null">Все Max ID</option>
        <option v-for="m in maxIdFilterOptions" :key="m.value" :value="m.value">
          {{ m.text }}
        </option>
      </select>

      <button
        class="btn btn-secondary"
        @click="
          search = '';
          roleFilter = null;
          passFilter = null;
          maxIdFilter = null;
        "
      >
        Сбросить
      </button>

      <span class="filter-counter">
        Показано: {{ filteredUsers.length }} / {{ users.length }}
      </span>
    </div>

    <table class="users-table">
      <thead>
        <tr>
          <th>№</th>
          <th>Логин</th>
          <th>Роль</th>
          <th>Комментарий</th>
          <th>ACT Tasks</th>
          <th>Фото</th>
          <th>Пропуск</th>
          <th>Max ID</th>
          <th>Действия</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(user, index) in filteredUsers" :key="user._id">
          <td>{{ index + 1 }}</td>
          <td>{{ user.username }}</td>
          <td>{{ user.role }}</td>
          <td>{{ user.comment || "—" }}</td>
          <td>
            <span
              v-if="user.actTasks && user.actTasks.enabled"
              style="color: green"
            >
              ✅ Включен
            </span>
            <span v-else style="color: gray"> ⛔ Отключен </span>
            <span
              v-if="user.actTasks && user.actTasks.role"
              style="margin-left: 5px; font-size: 12px; color: #666"
            >
              ({{ user.actTasks.role }})
            </span>
          </td>
          <td v-if="user.photo">
            <a :href="user.photo" target="_blank" rel="noopener noreferrer"
              >Ссылка</a
            >
          </td>
          <td v-else>Нет</td>

          <!-- ПРОПУСК -->
          <td>
            <div v-if="user.schoolPass" class="pass-cell">
              <span class="pass-badge pass-badge--ok">✅ Есть</span>
              <button
                class="delete-btn"
                title="Удалить пропуск"
                @click="deletePassForUser(user)"
              >
                ❌
              </button>
            </div>
            <div v-else class="pass-cell">
              <span class="pass-badge pass-badge--no">⛔ Нет</span>
              <button
                class="edit-btn"
                title="Создать пропуск"
                @click="createPassForUser(user)"
              >
                ➕
              </button>
            </div>
          </td>

          <td>
            <div v-if="user.MaxID">
              <span class="maxbot-id">{{ user.MaxID }}</span>
              <button
                @click="deleteMaxBotIdByUser(user)"
                class="delete-btn"
                title="Удалить ID MAX"
              >
                ❌
              </button>
            </div>
            <div v-else>
              <v-btn
                @click="addMaxBotIdtoUser(user)"
                color="primary"
                style="text-align: center"
              >
                Добавить
              </v-btn>
            </div>
          </td>
          <td>
            <button @click="openEditUser(user)" class="edit-btn">
              Редактировать
            </button>
            <button
              @click="deleteUser(user._id, user.username)"
              class="delete-btn"
            >
              Удалить
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Модалка добавления пользователя -->
    <v-dialog
      v-model="showAddUserModal"
      @close="showAddUserModal = false"
      width="400px"
      height="400px"
    >
      <div style="background-color: white; max-width: 600px; padding: 10px">
        <h3>Добавить пользователя</h3>
        <div>
          <div class="form-group">
            <label>Логин:</label>
            <input v-model="newUser.username" type="text" required />
          </div>
          <div class="form-group">
            <label>Пароль:</label>
            <input v-model="newUser.password" type="text" required />
          </div>
          <div class="form-group">
            <label>Роль:</label>
            <select v-model="newUser.role">
              <option value="teacher">Учитель</option>
              <option value="employee">Сотрудник</option>
              <option value="parent_special">Родитель</option>
              <option value="parent_comitet">Родительский комитет</option>
              <option value="admin">Администратор</option>
            </select>
          </div>
          <div class="form-group">
            <label>Фото (ссылка):</label>
            <input v-model="newUser.photo" type="text" required />
          </div>
          <div class="form-group">
            <label>Комментарий:</label>
            <input v-model="newUser.comment" type="text" />
          </div>
          <button class="submit-btn" @click="addUser()">Сохранить</button>
        </div>
      </div>
    </v-dialog>

    <!-- Модалка редактирования пользователя -->
    <v-dialog
      v-model="editUserShow"
      @close="editUserShow = false"
      width="500px"
      height="auto"
    >
      <div
        v-if="selectUser"
        style="background-color: white; max-width: 600px; padding: 20px"
      >
        <h3>Обновить пользователя</h3>
        <div>
          <div class="form-group">
            <label>Логин:</label>
            <input v-model="selectUser.username" type="text" required />
          </div>
          <div class="form-group">
            <label>Пароль:</label>
            <input v-model="selectUser.password" type="text" required />
          </div>
          <div class="form-group">
            <label>Роль:</label>
            <select v-model="selectUser.role">
              <option value="teacher">Учитель</option>
              <option value="employee">Сотрудник</option>
              <option value="parent_special">Родитель</option>
              <option value="parent_comitet">Родительский комитет</option>
              <option value="admin">Администратор</option>
            </select>
          </div>
          <div class="form-group">
            <label>Фото (ссылка):</label>
            <input v-model="selectUser.photo" type="text" required />
          </div>
          <div class="form-group">
            <label>Комментарий:</label>
            <input v-model="selectUser.comment" type="text" />
          </div>

          <!-- ACT TASKS НАСТРОЙКИ -->
          <div class="acttasks-card">
            <div class="acttasks-header">
              <span class="acttasks-title">⚙️ ACT Tasks</span>
              <label class="switch">
                <input
                  type="checkbox"
                  v-model="selectUser.actTasks.enabled"
                  true-value="true"
                  false-value="false"
                />
                <span class="switch-slider"></span>
              </label>
            </div>

            <div
              class="acttasks-status"
              :class="
                selectUser.actTasks.enabled === 'true' ||
                selectUser.actTasks.enabled === true
                  ? 'acttasks-status--on'
                  : 'acttasks-status--off'
              "
            >
              {{
                selectUser.actTasks.enabled === "true" ||
                selectUser.actTasks.enabled === true
                  ? "✅ Пользователь включён в ACT Tasks"
                  : "⛔ Пользователь отключён от ACT Tasks"
              }}
            </div>

            <transition name="fade">
              <div
                v-if="
                  selectUser.actTasks.enabled === 'true' ||
                  selectUser.actTasks.enabled === true
                "
                class="acttasks-role"
              >
                <label>Роль в ACT Tasks:</label>
                <select v-model="selectUser.actTasks.role">
                  <option value="user">👤 Пользователь</option>
                  <option value="manager">📋 Менеджер</option>
                  <option value="admin">👑 Администратор</option>
                </select>
                <div class="acttasks-hint">
                  <strong>user</strong> — только просмотр своих задач<br />
                  <strong>manager</strong> — создание задач, назначение
                  исполнителей<br />
                  <strong>admin</strong> — полный доступ
                </div>
              </div>
            </transition>
          </div>

          <button
            class="submit-btn"
            @click="editUser(selectUser)"
            style="margin-top: 15px"
          >
            Сохранить
          </button>
        </div>
      </div>
    </v-dialog>

    <v-dialog
      v-model="qr"
      width="70%"
      height="95%"
      style="background-color: white"
    >
      <div style="background-color: white">
        <school-pass-manager
          v-if="qr"
          :students="users"
          :className="''"
          @close="qr = false"
        ></school-pass-manager>
      </div>
    </v-dialog>

    <ImportUsersModal
      v-if="showImportModal"
      @close="showImportModal = false"
      @users-imported="handleUsersImported"
      :on-users-imported="loadUsers"
    />
  </div>
</template>

<script>
import SchoolPassManager from "./schoolPass/schoolPassManagerStudents.vue";
import TutorialDataService from "../services/TutorialDataService";
import ImportUsersModal from "./ImportUsersModal.vue";
import SchoolPassService from "../services/SchoolPassService";

export default {
  components: {
    SchoolPassManager,
    ImportUsersModal,
  },
  data() {
    return {
      qr: false,
      users: [],
      editUserShow: false,
      showAddUserModal: false,
      newUser: {},
      selectUser: null,
      showImportModal: false,

      // Фильтры и поиск
      search: "",
      roleFilter: null,
      passFilter: null,
      maxIdFilter: null,
      roleOptions: [
        { text: "Учитель", value: "teacher" },
        { text: "Сотрудник", value: "employee" },
        { text: "Родитель", value: "parent_special" },
        { text: "Родительский комитет", value: "parent_comitet" },
        { text: "Администратор", value: "admin" },
      ],
      passFilterOptions: [
        { text: "Есть пропуск", value: "has" },
        { text: "Нет пропуска", value: "no" },
      ],
      maxIdFilterOptions: [
        { text: "Есть Max ID", value: "has" },
        { text: "Нет Max ID", value: "no" },
      ],

      loading: false,
      passesLoaded: false,
    };
  },
  computed: {
    filteredUsers() {
      let list = [...this.users];

      if (this.search && this.search.trim()) {
        const s = this.search.toLowerCase().trim();
        list = list.filter((u) => (u.username || "").toLowerCase().includes(s));
      }

      if (this.roleFilter) {
        list = list.filter((u) => u.role === this.roleFilter);
      }

      if (this.passFilter === "has") {
        list = list.filter((u) => !!u.schoolPass);
      } else if (this.passFilter === "no") {
        list = list.filter((u) => !u.schoolPass);
      }

      if (this.maxIdFilter === "has") {
        list = list.filter((u) => !!u.MaxID);
      } else if (this.maxIdFilter === "no") {
        list = list.filter((u) => !u.MaxID);
      }

      return list;
    },
  },
  methods: {
    // === ЭКСПОРТ В EXCEL (CSV без библиотек) ===
    exportToExcel() {
      const rows = this.filteredUsers;
      if (!rows.length) {
        alert("⚠️ Нет данных для экспорта");
        return;
      }

      const headers = [
        "№",
        "Логин",
        "Роль",
        "Комментарий",
        "ACT Tasks включен",
        "ACT Tasks роль",
        "Фото",
        "Пропуск",
        "Max ID",
      ];

      const escape = (val) => {
        if (val === null || val === undefined) return "";
        const s = String(val).replace(/"/g, '""');
        return `"${s}"`;
      };

      const lines = [];
      lines.push(headers.map(escape).join(";"));

      rows.forEach((u, i) => {
        lines.push(
          [
            i + 1,
            u.username || "",
            u.role || "",
            u.comment || "",
            u.actTasks && u.actTasks.enabled ? "Да" : "Нет",
            u.actTasks && u.actTasks.role ? u.actTasks.role : "",
            u.photo || "",
            u.schoolPass ? "Есть" : "Нет",
            u.MaxID || "",
          ]
            .map(escape)
            .join(";"),
        );
      });

      // BOM для корректного UTF-8 в Excel
      const csvContent = "\uFEFF" + lines.join("\r\n");
      const blob = new Blob([csvContent], {
        type: "text/csv;charset=utf-8;",
      });

      const now = new Date();
      const pad = (n) => String(n).padStart(2, "0");
      const fileName = `users_${now.getFullYear()}-${pad(
        now.getMonth() + 1,
      )}-${pad(now.getDate())}_${pad(now.getHours())}-${pad(
        now.getMinutes(),
      )}.csv`;

      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", fileName);
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },

    // === MAX ID ===
    async addMaxBotIdtoUser(stud) {
      console.log(stud);

      const newMaxBotId = prompt(
        `Вы добавляете ID чата MAX для ${stud.FirstName} ${stud.LastName}. Ребенок должен передать Вам цифры, которые написал ему MAX-бот школы:`,
      );

      if (newMaxBotId !== null && newMaxBotId.trim() !== "") {
        try {
          await TutorialDataService.changeMaxIDUser({
            userID: stud._id,
            MaxID: newMaxBotId,
          })
            .then((res) => {
              console.log(res);
              if (res.status == 200) {
                alert(
                  `✅ ID чата MAX успешно добавлен для ${stud.FirstName} ${stud.LastName}: ${newMaxBotId}`,
                );
                stud.MaxID = newMaxBotId;
                this.$forceUpdate();
              }
            })
            .catch((e) => {
              console.log(e);
            });
        } catch (error) {
          console.error("Ошибка при добавлении ID:", error);
          alert(`❌ Ошибка при добавлении ID: ${error.message}`);
        }
      } else if (newMaxBotId !== null) {
        alert("⚠️ ID не может быть пустым");
      } else {
        alert("❌ Операция отменена");
      }
    },

    async deleteMaxBotIdByUser(stud) {
      if (
        !confirm(
          `Вы уверены? Удаление ID MAX для ${stud.FirstName} ${stud.LastName}`,
        )
      ) {
        return;
      }
      await TutorialDataService.deleteMaxIDUser({
        userID: stud._id,
        MaxID: null,
      })
        .then((res) => {
          console.log(res);
          if (res.status == 200) {
            alert(
              `✅ ID чата MAX успешно удален для ${stud.FirstName} ${stud.LastName}: `,
            );
            stud.MaxID = null;
            this.$forceUpdate();
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },

    // === ИМПОРТ ===
    handleUsersImported(result) {
      console.log("Импорт завершен:", result);
      alert(
        `Импорт завершен. Успешно: ${result.success}, С ошибками: ${result.failed}`,
      );
    },

    // === ДОБАВЛЕНИЕ ===
    addUserShow() {
      this.showAddUserModal = true;
      const generateRandomPassword = (length = 8) => {
        const chars =
          "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        let password = "";
        for (let i = 0; i < length; i++) {
          password += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return password;
      };
      this.newUser.password = generateRandomPassword();
    },

    openEditUser(user) {
      this.selectUser = {
        ...user,
        actTasks: user.actTasks || {
          enabled: false,
          role: "user",
          joinedAt: null,
        },
      };
      this.editUserShow = true;
      console.log(user, this.selectUser);
    },

    // === ЗАГРУЗКА ===
    async loadUsers() {
      try {
        const response = await TutorialDataService.getUsers();
        const users = (response.data || []).sort((a, b) =>
          (a.username || "").localeCompare(b.username || ""),
        );
        await this.loadPassesForUsers(users);
      } catch (error) {
        console.error("Ошибка загрузки пользователей:", error);
      }
    },

    async loadPassesForUsers(users) {
      if (!users || !users.length) {
        this.users = [];
        return;
      }

      this.loading = true;
      try {
        const userIds = users.map((u) => u._id);
        const response = await SchoolPassService.getPassesByUserIDs({
          userIds,
          dbName: "",
        });
        const passes = response.data.data || [];

        const merged = users.map((u) => {
          const pass = passes.find((p) => p.userID === u._id);
          return { ...u, schoolPass: pass || null };
        });

        merged.sort((a, b) =>
          (a.username || "").localeCompare(b.username || ""),
        );

        this.users = merged;
        this.passesLoaded = true;
      } catch (e) {
        console.error("Ошибка загрузки пропусков:", e);
        // даже если не загрузились пропуска — покажем пользователей
        this.users = users.map((u) => ({ ...u, schoolPass: null }));
      } finally {
        this.loading = false;
      }
    },

    // === ПРОПУСКА ===
    async createPassForUser(user) {
      try {
        const passData = {
          userID: user._id,
          name:
            `${user.LastName || ""} ${user.FirstName || ""} ${
              user.username || ""
            }`.trim() || user.username,
          role: user.role || "employee",
          type: "permanent",
          uniqueQR: `${user.role || "employee"}_${user._id}_${Date.now()}`,
        };

        const res = await SchoolPassService.createSchoolPass({
          ...passData,
          dbName: "",
        });

        this.$set(user, "schoolPass", res.data.data);
        this.$forceUpdate();
        alert(`✅ Пропуск для ${user.username} создан`);
      } catch (e) {
        console.error(e);
        alert("❌ Ошибка создания пропуска: " + e.message);
      }
    },

    async deletePassForUser(user) {
      if (!user.schoolPass) return true; // нечего удалять

      const ok = confirm(`Удалить пропуск у "${user.username}"?`);
      if (!ok) return false;

      try {
        await SchoolPassService.deletePassByID({
          id: user.schoolPass._id,
          dbName: "",
        });
        this.$set(user, "schoolPass", null);
        this.$forceUpdate();
        alert(`✅ Пропуск у "${user.username}" удалён`);
        return true;
      } catch (e) {
        console.error(e);
        alert("❌ Ошибка удаления пропуска: " + e.message);
        return false;
      }
    },

    // === СОХРАНЕНИЕ ===
    async addUser() {
      try {
        console.log(this.newUser);
        await TutorialDataService.createUser(this.newUser)
          .then((response) => {
            console.log(response);
            this.showAddUserModal = false;
            this.newUser = {
              username: "",
              password: "",
              role: "teacher",
              comment: "",
            };
            this.loadUsers();
          })
          .catch((e) => {
            console.log(e);
          });
      } catch (error) {
        console.error("Ошибка добавления пользователя:", error);
      }
    },

    async editUser(user) {
      console.log("Редактирование:", user);
      try {
        await TutorialDataService.updateUser(user)
          .then((response) => {
            console.log(response);
            this.loadUsers();
            this.editUserShow = false;
          })
          .catch((e) => {
            console.log(e);
          });
        this.loadUsers();
      } catch (error) {
        console.error("Ошибка обновления пользователя:", error);
      }
    },

    // === УДАЛЕНИЕ (С ЗАЩИТОЙ ПРОПУСКА) ===
    async deleteUser(userId, name) {
      const user = this.users.find((u) => u._id === userId);
      if (!user) return;

      // Если есть пропуск — сначала предупреждаем и удаляем пропуск
      if (user.schoolPass) {
        const ok = confirm(
          `У пользователя "${name}" есть пропуск.\n` +
            `Он будет удалён вместе с пользователем.\n` +
            `Продолжить?`,
        );
        if (!ok) return;

        const deleted = await this.deletePassForUser(user);
        if (!deleted) {
          alert("❌ Не удалось удалить пропуск. Пользователь НЕ удалён.");
          return; // прерываем — иначе останется «висячий» пропуск
        }
      } else {
        if (!confirm(`Удалить пользователя "${name}"?`)) return;
      }

      try {
        await TutorialDataService.deleteUser({ id: userId });
        // удаляем из локального массива
        this.users = this.users.filter((u) => u._id !== userId);
        alert(`✅ Пользователь "${name}" удалён`);
      } catch (error) {
        console.error("Ошибка удаления пользователя:", error);
        alert("❌ Ошибка удаления пользователя: " + error.message);
        // если пользователь не удалился — перезагрузим список
        this.loadUsers();
      }
    },
  },
  mounted() {
    this.loadUsers();
  },
};
</script>

<style scoped>
/* === ФИЛЬТРЫ === */
.filters-row {
  display: flex;
  gap: 10px;
  margin: 15px 0;
  align-items: center;
  flex-wrap: wrap;
}

.filter-input,
.filter-select {
  padding: 6px 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  min-width: 180px;
}

.filter-counter {
  margin-left: auto;
  font-size: 13px;
  color: #666;
}

.btn-secondary {
  padding: 6px 12px;
  background: #6c757d;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.btn-success {
  padding: 6px 12px;
  background: #217346; /* фирменный зелёный Excel */
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.btn-success:hover {
  background: #1a5c38;
}

/* === ПРОПУСК === */
.pass-cell {
  display: flex;
  align-items: center;
  gap: 6px;
}

.pass-badge {
  padding: 3px 8px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
}

.pass-badge--ok {
  background: #d4edda;
  color: #155724;
}

.pass-badge--no {
  background: #f8d7da;
  color: #721c24;
}

/* === ACT TASKS КАРТОЧКА === */
.acttasks-card {
  margin-top: 18px;
  padding: 16px;
  border: 1px solid #e1e4e8;
  border-radius: 10px;
  background: #fafbfc;
}

.acttasks-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.acttasks-title {
  font-weight: 600;
  font-size: 15px;
  color: #24292e;
}

.acttasks-status {
  font-size: 13px;
  padding: 8px 12px;
  border-radius: 6px;
  margin-bottom: 12px;
  transition: all 0.2s ease;
}
.acttasks-status--on {
  background: #e6f4ea;
  color: #1e7e34;
  border: 1px solid #b7e4c7;
}
.acttasks-status--off {
  background: #f1f3f5;
  color: #6c757d;
  border: 1px solid #dee2e6;
}

.acttasks-role label {
  display: block;
  margin-bottom: 6px;
  font-size: 13px;
  color: #24292e;
}
.acttasks-role select {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  background: #fff;
}

.acttasks-hint {
  font-size: 12px;
  color: #666;
  margin-top: 6px;
  line-height: 1.5;
}

/* === SWITCH (ТУМБЛЕР) === */
.switch {
  position: relative;
  display: inline-block;
  width: 46px;
  height: 24px;
  flex-shrink: 0;
}
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.switch-slider {
  position: absolute;
  cursor: pointer;
  inset: 0;
  background-color: #ccc;
  border-radius: 24px;
  transition: 0.25s;
}
.switch-slider::before {
  content: "";
  position: absolute;
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: #fff;
  border-radius: 50%;
  transition: 0.25s;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
}
.switch input:checked + .switch-slider {
  background-color: #28a745;
}
.switch input:checked + .switch-slider::before {
  transform: translateX(22px);
}

/* === ПЛАВНОЕ ПОЯВЛЕНИЕ === */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* === ОБЩИЕ === */
.settings {
  padding: 20px;
}

.settings-section {
  border: 1px solid #e1e4e8;
  border-radius: 6px;
  margin-bottom: 20px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.settings-section__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background-color: #f6f8fa;
  cursor: pointer;
  list-style: none;
  position: relative;
}

.settings-section__header::-webkit-details-marker {
  display: none;
}

.settings-section__toggle {
  position: relative;
  width: 16px;
  height: 16px;
}

.settings-section__toggle::before,
.settings-section__toggle::after {
  content: "";
  position: absolute;
  background-color: #24292e;
  transition: transform 0.3s ease;
}

.settings-section__toggle::before {
  width: 10px;
  height: 2px;
  top: 7px;
  left: 3px;
}

.settings-section__toggle::after {
  width: 2px;
  height: 10px;
  top: 3px;
  left: 7px;
}

.settings-section[open] .settings-section__toggle::after {
  transform: rotate(90deg);
}

.settings-section__content {
  padding: 16px;
  background-color: #fff;
}

.access-denied {
  text-align: center;
  padding: 40px;
  background: #f8d7da;
  border-radius: 8px;
  color: #721c24;
}

.back-link {
  display: inline-block;
  margin-top: 15px;
  color: #721c24;
  text-decoration: underline;
}

.admin-content {
  margin-top: 20px;
}

.add-user-btn {
  padding: 8px 16px;
  background: #006dc7;
  color: white;
  border: none;
  border-radius: 4px;
  margin-bottom: 15px;
  cursor: pointer;
}

.users-table {
  width: 100%;
  border-collapse: collapse;
  overflow-y: scroll;
}

.users-table th,
.users-table td {
  padding: 12px;
  border: 1px solid #ddd;
  text-align: left;
}

.studentsEditGroup th,
.studentsEditGroup td {
  padding: 3px;
}

.users-table th {
  background-color: #f8f9fa;
}

.edit-btn {
  padding: 5px 10px;
  background: #ffc107;
  border: none;
  border-radius: 4px;
  margin-right: 5px;
  cursor: pointer;
}

.delete-btn {
  padding: 5px 10px;
  background: #dc3545;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
}

.form-group input,
.form-group select {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.submit-btn {
  padding: 8px 16px;
  background: #28a745;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
</style>
